import EmbedPodcast, { type PodcastUrls } from '@/components/embeds/EmbedPodcast/EmbedPodcast'
import styles from './RTLMusicInline.module.scss'

export type WidgetRtlMusicContext = {
  readonly items?: ReadonlyArray<{
    readonly id: string
    readonly model: {
      readonly podcastUrls?: PodcastUrls
      readonly fields: {
        readonly html: string
      }
    }
  }>
}

export default function RTLMusicInline({
  item,
}: Readonly<{
  item: WidgetRtlMusicContext
}>) {
  return (
    <>
      {item.items?.map((embed) => (
        <div key={embed.id} className={styles.wrapper}>
          <EmbedPodcast html={embed.model.fields.html} podcastUrls={embed.model.podcastUrls} />
        </div>
      ))}
    </>
  )
}
